import find from "lodash/fp/find";

class Controller {
  constructor($injector, $stateParams, Lists, Sections) {
    "ngInject";

    const findByName = (name) => (item) => item.name === name;
    this.Lists = Lists.all;
    this.filter = $stateParams.type || "bookings_pickup_am";
    this.Station = $injector.get("Station");
    this.sections = Sections.routesSections;
    this.selected = {
      source: find(findByName("booking"))(this.Lists.stationsHeatmapSource),
      location: find(findByName("pickup"))(this.Lists.stationsHeatmapLocation),
      time: find(findByName("am"))(this.Lists.stationsHeatmapTime),
    };
    this.filters = [
      {
        title: "Data Source",
        name: "source",
        icon: "data_usage",
        list: this.Lists.stationsHeatmapSource,
      },
      {
        title: "Location Type",
        name: "location",
        icon: "location_on",
        list: this.Lists.stationsHeatmapLocation,
      },
      {
        title: "Time of Day",
        name: "time",
        icon: "access_time",
        list: this.Lists.stationsHeatmapTime,
      },
    ];
  }

  $onInit() {
    const get = () => {
      this.Station.heatmap(this.filter).$promise.then((response) => {
        this.heatmapData = [...response.hits];
      });
    };

    get();

    this.onListSelect = (selected) => {
      const filters = this.filter.split("_");
      const selectedIndex =
        selected.type === "source" ? 0 : selected.type === "location" ? 1 : 2;

      filters[selectedIndex] = selected.name;
      this.filter = filters.join("_");
      get();
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/stationsHeatmap/stationsHeatmap.controller.js